var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "col-12" }, [
        _c("h2", [_vm._v("Materiais para Download")]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-3" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "success", size: "sm" },
                  on: {
                    click: function($event) {
                      return _vm.showModal(-1)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _vm._v(" Adicionar Material\r\n                ")
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-3" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "mt-3 card p-3" }, [
              _c("table", { staticClass: "table table-bordered table-hover" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.materiaisDownload, function(material, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [_vm._v(_vm._s(material.id))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(material.descricao))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(material.regiao ? material.regiao : ""))
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(material.classe))]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-center" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              target: "_blank",
                              href: "/storage/" + material.path
                            }
                          },
                          [_c("i", { staticClass: "fas fa-file fa-lg" })]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.showModal(index)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-edit" })]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "danger" },
                              on: {
                                click: function($event) {
                                  return _vm.deleteMaterial(index)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-trash-alt" })]
                          )
                        ],
                        1
                      )
                    ])
                  }),
                  0
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            size: "lg",
            title: _vm.criar
              ? "Adicionar Material para Download"
              : "Editar Material para Download"
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _vm.criar && !_vm.statusEnviando
                    ? _c(
                        "b-button",
                        {
                          staticClass: "float-right mr-2",
                          attrs: { variant: "primary", size: "sm" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.postMaterial.apply(null, arguments)
                            }
                          }
                        },
                        [_vm._v("Enviar")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.criar && !_vm.statusEnviando
                    ? _c(
                        "b-button",
                        {
                          staticClass: "float-right mr-2",
                          attrs: { variant: "primary", size: "sm" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.postMaterial.apply(null, arguments)
                            }
                          }
                        },
                        [_vm._v("Salvar")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.statusEnviando
                    ? _c(
                        "b-button",
                        {
                          staticClass: "float-right mr-2",
                          attrs: {
                            variant: "warning",
                            size: "sm",
                            disabled: ""
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-spinner fa-spin fa-fw"
                          }),
                          _vm._v(" Enviado... ")
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right mr-2",
                      attrs: { variant: "danger", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.openedModal = false
                        }
                      }
                    },
                    [_vm._v(" Fechar ")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.openedModal,
            callback: function($$v) {
              _vm.openedModal = $$v
            },
            expression: "openedModal"
          }
        },
        [
          _c(
            "b-card",
            [
              _c(
                "b-card-body",
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Descrição")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newMaterialDownload.descricao,
                          expression: "newMaterialDownload.descricao"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.newMaterialDownload.descricao },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.newMaterialDownload,
                            "descricao",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "" } }, [_vm._v("Classes")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newMaterialDownload.classe,
                          expression: "newMaterialDownload.classe"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.newMaterialDownload.classe },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.newMaterialDownload,
                            "classe",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("v-tag", {
                    attrs: { regioes: _vm.regioes },
                    on: { alteraRegiao: _vm.alteraRegiao }
                  }),
                  _vm._v(" "),
                  !_vm.arquivoUpload
                    ? _c(
                        "div",
                        { staticClass: "mt-3" },
                        [
                          _vm.criar
                            ? _c("h6", [
                                _vm._v(
                                  "\r\n                        Escolha um Arquivo. "
                                ),
                                _c("small", [_vm._v("(limite de 60 MB)")])
                              ])
                            : _c("h6", [
                                _vm._v(
                                  "\r\n                        Escolha um novo Arquivo. "
                                ),
                                _c("small", [_vm._v("(limite de 60 MB)")])
                              ]),
                          _vm._v(" "),
                          _c("b-form-file", {
                            attrs: { placeholder: "Selecione um Arquivo..." },
                            on: { change: _vm.onFileChange }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "mt-3" },
                        [
                          _vm._v(
                            "\r\n                    " +
                              _vm._s(_vm.arquivoUpload) +
                              "\r\n                    "
                          ),
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "danger", size: "sm" },
                              on: { click: _vm.removeImage }
                            },
                            [_vm._v("Remover Arquivo")]
                          )
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-center" }, [_vm._v("id")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Descrição")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Região")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Classe")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Arquivo")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Editar")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Deletar")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64d83682", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64d83682","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/material_download/Main.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-64d83682","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/material_download/Main.vue
// module chunks = 2